import { MaskedInput } from 'baseui/input';
import React from 'react';
import { dobValidity, futureDateValidity } from './validators/dateValidity';

const DateInput = ({ id, updateInput, value, onFocus }) => {
   return (
      <MaskedInput
         onChange={(e) => updateInput(e.target.value)}
         placeholder='dd/mm/yyyy'
         onFocus={onFocus}
         mask='99/99/9999'
         value={value || ''}
         name={id}
      />
   );
}

export const FutureDateInput = {
   inputName: 'futureDate',
   Component: DateInput,
   defaultValue: "",
   validator: (value) => futureDateValidity(value, 2100)
}

export const PreviousDateInput = {
   inputName: 'prevDate',
   Component: DateInput,
   defaultValue: "",
   validator: (value) => dobValidity(value)
}

export default DateInput;
